module.exports = __webpack_public_path__ + "static/media/IS Office Safety Precautions.b23149eb.pdf";